// Copyright (c) StrangeBee 2023

import { classList } from '@Helpers/className';
import React, { Children, ReactElement, ReactNode } from 'react';

import './Slot.scss';

const listClasses: Record<'MANAGE' | 'NAVIGATION' | 'CONTENT', string> = {
    MANAGE: 'th-slot__manage',
    NAVIGATION: 'th-slot__navigation',
    CONTENT: 'th-slot__content',
};

export interface SlotProps {
    children: ReactNode[] | ReactNode;
    name: 'MANAGE' | 'NAVIGATION' | 'CONTENT';
    className?: string;
}

export const Slot = ({ children, name, className }: SlotProps): ReactElement | null => {
    const elements = Children.toArray(children);

    if (elements.every((value) => !value)) {
        return null;
    }

    return <div className={classList(listClasses[name], className)}>{children}</div>;
};

Slot.displayName = 'Slot';
